import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { lightTheme } from '../../themes';

class GenericDialog extends Component {
  render() {
    const { open, onClose, title, children, buttons } = this.props;
    return (
      <MuiThemeProvider theme={lightTheme}>
        <Dialog open={open} onClose={onClose}>
          {title && (
            <DialogTitle>
              {this.props.title}
            </DialogTitle>
          )}
          <DialogContent>
            <DialogContentText>
              {children}
            </DialogContentText>
          </DialogContent>
          { buttons && (
            <DialogActions>
              { buttons.map(({ text, onClick }, index) => (
                <Button key={index} color="inherit" onClick={onClick}>{text}</Button>
              ))}
            </DialogActions>
          )}
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

GenericDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })),
};

export default GenericDialog;



// WEBPACK FOOTER //
// ./src/components/dialogs/GenericDialog.js